import { FC, ReactNode } from 'react';
import { Tooltip } from 'antd';

type VisitTabTooltipProps = {
  visitName: string;
  // Whether the visit has data (e.g. uploaded files / uploads to validate).
  hasData: boolean;
  isActive: boolean;
  children: ReactNode;
};

// Tooltip for a visit tab: shows the visit name, or a "no data" hint for
// non-active visits without data. Shared by the External User and Validation
// Specialist subject-detail tabs.
export const VisitTabTooltip: FC<VisitTabTooltipProps> = ({
  visitName,
  hasData,
  isActive,
  children,
}) => (
  <Tooltip
    color='white'
    title={
      <span className='text-1424 text-black'>
        {hasData || isActive ? visitName : 'No data for current visit'}
      </span>
    }
  >
    {children}
  </Tooltip>
);
